module.exports = __webpack_public_path__ + "media/images/850/gym-17d7c3959243938e0a86342f74d8f7b8.jpg";